// Basic
import PropTypes from 'prop-types';
// Store and actions
import useRootOrganizationStore from '@/app/store/rootOrganization';
import usePlansStore from '@/app/store/modules/plan';
import actionsOrganizations from '@/app/modules/organizations/api/actionsOrganizations';
// Components
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import Entity from '@/common-utils/components/renders/entity/Entity';
import FooterForm from '@/common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import { Modal, ModalBody, ModalContent } from '@/common-utils/components/ui/modal';
// Common
import { useToast } from '@/common-utils/hooks/use-toast';
import { nsPlan } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.isOpen
 * @param root0.setIsOpen
 * @returns {JSX} ModalBlockNewPos
 */
function ModalBlockNewPos({ isOpen, setIsOpen }) {

    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const { shouldBlockNewPOS, storeRefetchPlans } = usePlansStore();

    // Toast
    const { toast } = useToast();

    // Api calls
    const onSuccess = () => {
        setIsOpen(false);
        storeRefetchPlans(true);
        toast({
            description: <Entity
                namespace={nsPlan}
                entity={shouldBlockNewPOS ? 'modal.unblock_new_pos.success' : 'modal.block_new_pos.success'}
                nowrap
            />,
            variant: 'success'
        });
    };

    const onError = () => {
        toast({
            description: <Entity namespace={nsPlan} entity={shouldBlockNewPOS ? 'modal.unblock_new_pos.error' : 'modal.block_new_pos.error'} />,
            variant: 'danger'
        });
    };

    const updateOrganization = actionsOrganizations.updateOrganization(onSuccess, onError);

    // Functions
    const onSubmit = () => {
        updateOrganization.mutate({
            organizationId: rootOrganization.uuid,
            organizationData: rootOrganization,
            shouldBlockNewPOS: !shouldBlockNewPOS
        });
    };

    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            <ModalContent className='max-w-xl'>
                <HeaderTitle
                    title={shouldBlockNewPOS ? 'modal.unblock_new_pos.title' : 'modal.block_new_pos.title'}
                    namespace={nsPlan}
                />
                <ModalBody className='modal-max-height overflow-auto'>
                    <div className='text-center grid gap-6'>
                        <Entity
                            entity={shouldBlockNewPOS ? 'modal.unblock_new_pos.warning' : 'modal.block_new_pos.warning'}
                            namespace={nsPlan}
                        />
                        <Entity
                            entity={shouldBlockNewPOS ? 'modal.unblock_new_pos.validate_question' : 'modal.block_new_pos.validate_question'}
                            namespace={nsPlan}
                        />
                    </div>
                </ModalBody>
                <FooterForm
                    onSubmit={onSubmit}
                    isSubmitting={updateOrganization.isLoading}
                    isSubmitDisabled={false}
                    showSubmitButton={true}
                />
            </ModalContent>
        </Modal>
    );
}

ModalBlockNewPos.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired
};

export default ModalBlockNewPos;